"use client";

import React from "react";
import Image from "next/image";
import { format } from "date-fns";
import { useParams } from "next/navigation";
import { useLocale } from "@/hooks/useLocale";
import Like from "@/components/molecules/Like/Like";
import { League } from "@/types/league";

interface LeagueInfoProps {
  selectedLeague: League;
}

const LeagueInfo: React.FC<LeagueInfoProps> = ({ selectedLeague }) => {
  const params = useParams();
  const { locale } = params;
  const dateFnsLocale = useLocale(locale as string);

  return (
    <div className="leagueInfo-wrapper">
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${selectedLeague.logo || selectedLeague.countryFlag})`,
        }}
      ></div>
      <div className="p-2 mt-0" style={{ minHeight: "11rem" }}>
        <div className="d-flex justify-content-between justify-content-md-start">
          <div
            className="p-2"
            style={{
              backgroundColor: "var(--primary-color)",
              borderRadius: "5px",
              height: "max-content",
            }}
          >
            {selectedLeague.logo && (
              <Image
                src={selectedLeague.logo}
                alt={selectedLeague.logo}
                width={100}
                height={100}
                loading="lazy" 
              />
            )}
          </div>
          <div className="d-flex me-2">
            <div
              className="flex-column ms-4 p-2 text-start"
              style={{
                backgroundColor: "var(--primary-color)",
                borderRadius: "5px",
              }}
            >
              <h1>
                <strong>{selectedLeague.name}</strong>
              </h1>
              <div className="d-flex align-items-center">
                {selectedLeague.countryFlag && (
                  <Image
                    src={`/icons/flags/${selectedLeague.countryCode?.toLowerCase()}.svg`}
                    alt={selectedLeague.countryName!}
                    width={35}
                    height={25}
                    loading="lazy" 
                  />
                )}
                <h3>&nbsp;{selectedLeague.countryName}</h3>
              </div>
              <h6>
                {format(new Date(selectedLeague.startdate), "dd MMM yy", {
                  locale: dateFnsLocale,
                })}{" "}
                -{" "}
                {format(new Date(selectedLeague.enddate), "dd MMM yy", {
                  locale: dateFnsLocale,
                })}
              </h6>
            </div>
          </div>
          <div className="ms-auto m-2">
            <Like itemType="league" itemId={selectedLeague.id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeagueInfo;
